import { render, staticRenderFns } from "./testMethod.vue?vue&type=template&id=4b9e56c8&scoped=true&"
import script from "./testMethod.vue?vue&type=script&lang=js&"
export * from "./testMethod.vue?vue&type=script&lang=js&"
import style0 from "./testMethod.vue?vue&type=style&index=0&id=4b9e56c8&scoped=true&lang=scss&"
import style1 from "./testMethod.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e56c8",
  null
  
)

export default component.exports